import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import AirportSpotSummary from 'common/airport/AirportSpotSummary';
import StarRatingWithCategory from 'common/star-rating/StarRatingWithCategory';
import Image from 'common/image/Image';
import withConfig from 'config/withConfig';
import BenefitMessage from './BenefitMessage';

export const SpotDetailsHeader = ({
    facility,
    comparisons,
    isAdmin,
    staticBaseUrl,
}) => {
    const {
        id,
        title,
        logos,
        images,
        rating_info: ratingInfo,
        airport,
        amenities_full: amenitiesList,
        distance,
    } = facility;
    const {
        details: {code: iataCode},
    } = airport;
    const {
        number_of_ratings: numberOfReviews,
        star_rating: starRating,
    } = ratingInfo;
    const logoId =
        logos && logos.length > 0
            ? logos[0].id
            : images && images.length > 0
            ? images[0].id
            : null;
    const logoProps = {
        width: 144,
        height: 144,
        alt: `Photo of ${title}`,
        ...(logoId
            ? {cloudinaryImageId: logoId}
            : {src: `${staticBaseUrl}img/missing-image.png`}),
    };

    return (
        <div className="SpotDetailsHeader">
            <div className="SpotDetailsHeader-top-content">
                <div className="SpotDetailsHeader-photo">
                    <Image {...logoProps} />
                </div>
                <div className="SpotDetailsHeader-details">
                    <BenefitMessage
                        comparisons={comparisons}
                        iataCode={iataCode}
                        ratingInfo={ratingInfo}
                    />
                    <h2 itemProp="name">{unescape(title)}</h2>
                    <StarRatingWithCategory
                        numberOfReviews={numberOfReviews}
                        starRating={starRating}
                    />
                    {isAdmin && (
                        <a
                            className="SpotDetailsHeader-admin-link"
                            href={`/admin/spots/${id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Facility Admin Page
                        </a>
                    )}
                    <AirportSpotSummary
                        data={airport}
                        amenities={amenitiesList}
                        distanceInMiles={distance}
                    />
                </div>
            </div>
            <div className="SpotDetailsHeader-bottom-content">
                <AirportSpotSummary
                    data={airport}
                    amenities={amenitiesList}
                    distanceInMiles={distance}
                />
            </div>
        </div>
    );
};

SpotDetailsHeader.propTypes = {
    facility: PropTypes.object.isRequired,
    comparisons: PropTypes.object,
    isAdmin: PropTypes.bool.isRequired,
    staticBaseUrl: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
    const {
        user: {
            data: {isAdmin},
        },
    } = state;

    return {
        isAdmin,
    };
};

const enhance = compose(
    withConfig(['staticBaseUrl']),
    connect(mapStateToProps)
);

export default enhance(SpotDetailsHeader);
